import { render, staticRenderFns } from "./PeerCount.vue?vue&type=template&id=49048a5b&scoped=true&"
import script from "./PeerCount.vue?vue&type=script&lang=ts&"
export * from "./PeerCount.vue?vue&type=script&lang=ts&"
import style0 from "./PeerCount.vue?vue&type=style&index=0&id=49048a5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49048a5b",
  null
  
)

export default component.exports